import { WallButton } from "@package/ui-components";
import { useDispatchWall, useSelectorWall } from "@package/ui-redux";
import { sliceWallUpdateVideoSource } from "@package/ui-wall-engine";
import ReactWebcam from "react-webcam";

export function VideoInput() {
  const device = useSelectorWall((state) => state.wall.device);
  const deviceId = useSelectorWall((state) => state.wall.videoSource);
  const dispatch = useDispatchWall();

  if (device?.screens?.videoSource?.enabled && deviceId) {
    return (
      <div
        className="absolute z-50 overflow-hidden bg-slate-900"
        style={{
          left: device?.screens?.videoSource?.x ?? 0,
          top: device?.screens?.videoSource?.y ?? 0,
          width: device?.screens?.videoSource?.width ?? 0,
          height: device?.screens?.videoSource?.height ?? 0,
        }}
      >
        <ReactWebcam
          audio
          disablePictureInPicture
          height="100%"
          width="100%"
          videoConstraints={{
            deviceId,
          }}
        />
        {!!device?.screens?.videoSource?.showCloseButton && (
          <div className="absolute bottom-4 right-0">
            <WallButton
              align="right"
              icon="cross"
              intent="danger"
              onHandleMouse={() => {
                dispatch(sliceWallUpdateVideoSource(undefined));
              }}
            />
          </div>
        )}
      </div>
    );
  }

  return null;
}
